import { useLocation } from 'react-router-dom';

export const usePathWithParams = () => {
  const location = useLocation();
  return `${location.pathname}${location.search}${location.hash}`;
};
